import React, { useState } from 'react'
import { SingleDatePicker } from 'react-dates'
import { InputGroup } from 'react-bootstrap'
import moment from 'moment'

const DateFilter = ({
    value,
    onChange = () => {},
    placeholder
}) => {

    const [pickerVisible, setVisible] = useState(false)

    const onDateChange = (momentDate) => {
        if(moment(momentDate).isValid()) {
            onChange(momentDate.toDate())
        }
    }


    return (
        <InputGroup className="mb-3">
            <SingleDatePicker
                placeholder={placeholder}
                date={value ? moment(value) : undefined}
                onDateChange={date => onDateChange(date)}
                focused={pickerVisible}
                onFocusChange={({ focused }) => setVisible(focused)}
                numberOfMonths={1}
                hideKeyboardShortcutsPanel
                regular
                showClearDate
                isOutsideRange={() => false}
            />
        </InputGroup>
    )
}

export default DateFilter